/* eslint-disable arrow-body-style */
/* eslint-disable react/jsx-no-bind, react/no-multi-comp */
import React, {useEffect, useState} from "react";
import API from "../../shared/modules/API";
import PropTypes from "prop-types";
import consumer from "../../../../app/assets/javascripts/channels/consumer";

const CartIcon = ({handleOpenCartModal}) => {
  const [
    cartItemCount,
    setCartItemCount
  ] = useState(0);

  const isCustomer = () => {
    if (API.CUSTOMER_ID) return true;
    return false;
  };

  useEffect(() => {
    console.log("connecting");
    consumer.subscriptions.create({
      "channel": "CartNotificationChannel",
      "identifier": JSON.stringify({
        "id": isCustomer() ? API.CUSTOMER_ID : API.ANONYMOUS_CONTACT_ID,
        "is_customer": isCustomer()
      })
    }, {
      connected () {
        // Called when the subscription is ready for use on the server
        console.log("Connected to the cart notification channel!");
      },

      disconnected () {
        // Called when the subscription has been terminated by the server
        console.log("Disconnected from the cart notification channel!");
      },

      received (data) {
        // Called when there's incoming data on the websocket for this channel
        console.log("Received data from the cart notification channel data: ", data);
        setCartItemCount(data.active_cart_item_count);
      }
    });
  }, []);

  const renderItemCount = () => {
    if (cartItemCount > 0) {
      return (
        <div
          className="cart-icon-notification"
          id="active-cart-item-count"
        >
          {cartItemCount}
        </div>
      );
    }

    return null;
  };

  return (
    <div className="cart-icon">
      <div
        className="cart-icon-button"
        onClick={handleOpenCartModal}
        type="button"
      />
      {renderItemCount()}
    </div>
  );
};

CartIcon.propTypes = {"handleOpenCartModal": PropTypes.func.isRequired};

export default CartIcon;
